import { AlertDialog, Button, Flex, IconButton } from "@radix-ui/themes";
import { X } from "lucide-react";

interface UiAlertProps {
  children: React.ReactNode;
  title: string;
  message: string;
  okLabel?: string;
  cancelLabel?: string;
  onCancel?: () => void;
  onOk?: () => void;
}

export function UiAlert({
  children,
  title,
  message,
  onCancel,
  onOk,
  okLabel,
  cancelLabel,
}: UiAlertProps) {
  return (
    <AlertDialog.Root>
      <AlertDialog.Trigger>{children}</AlertDialog.Trigger>
      <AlertDialog.Content maxWidth="450px">
        <Flex justify="between" align="center">
          <AlertDialog.Title>{title}</AlertDialog.Title>
          <AlertDialog.Cancel>
            <IconButton
              variant="ghost"
              color="red"
              style={{ cursor: "pointer", alignSelf: "flex-start" }}
            >
              <X size={20} />
            </IconButton>
          </AlertDialog.Cancel>
        </Flex>
        <AlertDialog.Description size="2">{message}</AlertDialog.Description>

        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button onClick={onCancel} variant="soft" color="gray">
              {cancelLabel ?? "Annuler"}
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button onClick={onOk} variant="solid" color="green">
              {okLabel ?? "Valider"}
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
}
